import { Button, styled } from "@mui/material";
import useLanguage from "../../hooks/useLanguage";

const FlexableButton = styled(Button)`
  &.rtl .MuiButton-endIcon {
    margin-left: 0;
    margin-right: 8px;
  }

  &.rtl .MuiButton-startIcon {
    margin-left: 8px;
    margin-right: 0;
  }
`;

export default function IButton({ ...props }) {
  const [{ direction }] = useLanguage();

  return (
    <FlexableButton {...props} className={props.className + " " + direction} />
  );
}
